<template>
  <v-layout row :class="['announcement-type-alert-card', type && `announcement-type-alert-card__${type}`]">
    <v-flex class="announcement-type-alert-card__icon">
      <i class="material-icons">campaign</i>
    </v-flex>
    <v-flex class="announcement-type-alert-card__main">
      <div class="announcement-type-alert-card__main--box-1 mb-2"></div>
      <div class="announcement-type-alert-card__main--box-2 mb-1"></div>
      <div class="announcement-type-alert-card__main--box-2 mb-3"></div>
      <div class="announcement-type-alert-card__main--box-3"></div>
    </v-flex>
    <v-flex class="announcement-type-alert-card__icon"><v-icon size="18">fas fa-times</v-icon></v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'AnnouncementTypeAlertCard',
  props: {
    type: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.announcement-type-alert-card {
  width: 100%;
  padding: 7px 2px 7px 10px;
  border: 1px solid $black;
  border-radius: 8px;

  &__icon {
    i {
      color: $black;
    }
  }

  &__main {
    margin-top: 5px;
    padding: 0 15px 0 10px;
    width: calc(100% - 60px);

    @include breakpointMin(sm) {
      padding: 0 30px 0 10px;
    }

    &--box-1 {
      height: 12px;
      width: 110px;
      background-color: rgb($black, 0.5);
    }

    &--box-2 {
      height: 7px;
      width: 100%;
      background-color: rgb($black, 0.5);
    }

    &--box-3 {
      height: 20px;
      width: 70px;
      border-radius: 8px;
      background-color: $black;
    }
  }

  &__warning {
    border: 1px solid $ypo-error-red;

    i {
      color: $ypo-error-red;
    }

    .announcement-type-alert-card__main {
      &--box-1, &--box-2 {
        background-color: rgb($ypo-error-red, 0.5);
      }

      &--box-3 {
        background-color: $ypo-error-red;
      }
    }
  }

  &__general {
    border: 1px solid $ypo-brand-blue;

    i {
      color: $ypo-brand-blue;
    }

    .announcement-type-alert-card__main {
      &--box-1, &--box-2 {
        background-color: rgb($ypo-brand-blue, 0.5);
      }

      &--box-3 {
        background-color: $ypo-brand-blue;
      }
    }
  }
}
</style>

